export class BillNumberRequest {
   billNumber:string
   operation?:string
   contractorId ?:number
   fromDate?: string
   toDate?:string
   
    constructor(billNumber:string,operation?:string,contractorId ?:number,fromDate?: string,
        toDate?:string) {
        this.billNumber=billNumber
        this.operation=operation
        this.contractorId = contractorId
        this.fromDate = fromDate
        this.toDate = toDate

    }
}
